export const PRECIO_CONDICION = '* Precio sujeto a cambios';